import React from 'react';
import '../../../App.css';


const ProductPageH2 = ({
    children
}) => {
    return (
        <h2 style={{ marginTop: '80px', marginBottom: '30px' }}>{children}</h2>
    );
};

export default ProductPageH2;
